var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"2.343vw","height":"2.343vw","background":"transparent","position":"relative"}},[_c('canvas',{ref:"slidableRingCanvas",attrs:{"width":"60","height":"60"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }